import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Divider,
  Button,
  IconButton,
  Paper,
  Modal,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { uploadImage, deleteImage } from "services/imageUpload";
import { IMAGE_URL } from "network";

const Overview = ({
  overviewData = [],
  onChange,
  deletedFiles = [],
  setDeletedFiles,
  error,
  touched,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [newItem, setNewItem] = useState({
    image: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const sliderRef = useRef(null);

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  const handleAddItem = () => {
    const updated = [...overviewData, newItem];
    onChange(updated);
    setOpenModal(false);
    setNewItem({
      image: "",
    });
    setPreviewImage("");
  };

  const handleDeleteItem = (index) => {
    const updated = overviewData.filter((_, i) => i !== index);
    onChange(updated);
  };

  const delmedia = async (image) => {
    setDeletedFiles(image);
  };

  useEffect(() => {
    if (overviewData.length > 0 && sliderRef.current) {
      // Scroll to last slide
      sliderRef.current.slickGoTo(overviewData.length - 1);
    }
  }, [overviewData]);

  return (
    <Box sx={{ mt: 4 }}>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        Overview*
      </Typography>
      <Box sx={{ py: 2 }}>
        <Slider ref={sliderRef} {...sliderSettings}>
          {overviewData.map((item, index) => (
            <div key={index}>
              <Paper sx={{ mx: 1, p: 2, position: "relative" }}>
                <IconButton
                  onClick={() => handleDeleteItem(index)}
                  sx={{ position: "absolute", top: 8, right: 8 }}
                >
                  <Delete color="error" onClick={() => delmedia(item.image)} />
                </IconButton>
                <img
                  crossorigin="anonymous"
                  src={IMAGE_URL + item.image}
                  alt={item.name}
                  onError={(e) => (e.target.src = "/fallback.jpg")}
                  style={{ width: "100%", height: 100, objectFit: "cover" }}
                />
              </Paper>
            </div>
          ))}
          <div>
            <Paper
              onClick={() => setOpenModal(true)}
              sx={{
                mx: 1,
                height: 200,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                border: "2px dashed #ccc",
              }}
            >
              <Add fontSize="large" />
              <Typography>Add Overview</Typography>
            </Paper>
          </div>
        </Slider>
      </Box>

      {error && touched && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}

      {/* Modal for Adding Item */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Add Overview
          </Typography>

          <input
            type="file"
            accept="image/*"
            onChange={async (e) => {
              const file = e.target.files[0];
              if (file) {
                const uploadedPath = await uploadImage(file);
                setNewItem({ ...newItem, image: uploadedPath });
                setPreviewImage(IMAGE_URL + uploadedPath);
              }
            }}
          />
          {previewImage && (
            <Box mt={2}>
              <img
                crossorigin="anonymous"
                src={previewImage}
                alt="preview"
                style={{ width: "100%", height: 100, objectFit: "cover" }}
              />
            </Box>
          )}

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button variant="outlined" onClick={() => setOpenModal(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleAddItem}
              disabled={!newItem.image}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Overview;
